import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Ferry Auth Service
 * Kullanıcıya özel feribot işlemleri (yolcu listesi vb.)
 */
export const ferryAuthService = {
  /**
   * Kullanıcının kayıtlı yolcularını getirir.
   * @param {number} userId - Kullanıcı ID'si
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Usage Example:
   * getPassengers(123)
   * → GET /sakaFerryUser/passengers?userId=123
   */
  getPassengers: (userId, headers = {}, hasErrorHandler = false) => {
    if (!userId) {
      return Promise.reject(new Error("User ID is required"));
    }

    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.auth.getPassengers}?userId=${userId}`,
      payload: {},
      headers,
      hasErrorHandler,
    });
  },
};

